// extracted by mini-css-extract-plugin
export default {"main":"Certificates_main__YgDdr","list":"Certificates_list__t4wR3"};